import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { FormattedMessage } from 'react-intl'

import { getList } from './../store/reducers/partners'

const PartnersPage = ({ items = {}, categories }) => (
  <div className='Partners'>
    <div className='Container Container_light'>
      <h1 className='Head Partners__title'>
        <FormattedMessage id='partners.partners' />
      </h1>
      <p className='Text Partners__caption'>
        <FormattedMessage id='partners.write_us' />
        {': '}
        <a href='mailto:partner@meetforcharity.today' className='Link'>partner@meetforcharity.today</a>
      </p>

      { categories.map(category => (
        <div className='Partners__list' key={category._id}>
          {category.items.map(itemId => {
            if (!items[itemId] || !items[itemId].image) return null
            return (
              <div className='Partners__img'>
                <img src={items[itemId].image} alt={items[itemId].name} key={`image-${itemId}`} />)}
              </div>
            )
          })}
        </div>
      ))}
    </div>
  </div>
)

const mapStateToProps = state => ({
  ...state.partners,
  currentLocale: state.intl.locale
})

const mapDispatchToProps = dispatch => bindActionCreators({ getList }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount () {
      if (!this.props.items || !this.props.items.length) this.props.getList()
    }
  })
)(PartnersPage)



// WEBPACK FOOTER //
// ./src/containers/Partners.jsx